import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_GBE_ERROR_NOTIFICATION } from '@core/interceptors/gbe-error.interceptor';
import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';
import { OptimizationArtifactsResponse } from '@core/models/optimization-artifacts.model';
import { GBE_BASE_URL } from '@core/tokens/gbe-url.token';

/**
 * Client for the debug artifacts persisted by an optimization run (gated by the
 * `optimization_artifacts` permission). Errors are surfaced inline by the
 * dropdown, so the global GBE notification is suppressed.
 */
@Injectable({ providedIn: 'root' })
export class OptimizationArtifactsService {
  private readonly http = inject(HttpClient);
  private readonly gbeUrl = inject(GBE_BASE_URL);

  private buildUrl(endpoint: string): string {
    return `${this.gbeUrl}/${endpoint}`;
  }

  listArtifacts$(optimizationId: string): Observable<OptimizationArtifactsResponse> {
    return this.http.get<OptimizationArtifactsResponse>(
      this.buildUrl(`${GbeEndPointV4.OPTIMIZATIONS}/${optimizationId}/artifacts`),
      { context: new HttpContext().set(SKIP_GBE_ERROR_NOTIFICATION, true) }
    );
  }

  downloadArtifact$(optimizationId: string, artifactId: string): Observable<Blob> {
    return this.http.get(
      this.buildUrl(
        `${GbeEndPointV4.OPTIMIZATIONS}/${optimizationId}/artifacts/${artifactId}/download`
      ),
      {
        responseType: 'blob',
        context: new HttpContext().set(SKIP_GBE_ERROR_NOTIFICATION, true)
      }
    );
  }
}
